import { Component } from '@angular/core';
import { BaseComponent } from 'src/app/core/base/base.component';
import { NOT_FOUND_CONSTANTS } from './not-found.constants';
import { NotFoundService } from './not-found.service';

@Component({
  selector: 'ms-not-found',
  templateUrl: './not-found.template.html',
  styleUrls: ['not-found.component.scss'],
})
export class NotFoundViewComponent extends BaseComponent {
  readonly screen = NOT_FOUND_CONSTANTS;

  constructor(protected service: NotFoundService) {
    super();
  }

  onInit = () => {
    this.service.setScreenInformation({ id: '404' });
  };
}
